module.exports = __webpack_public_path__ + "static/media/about-photo-background.950a319b.svg";